var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          staticClass: "btn btn--primary btn--outline",
          on: { click: _vm.open },
        },
        [_vm._v("\n    " + _vm._s(_vm.campaignCta) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.isOpen === true
        ? _c("portal", { attrs: { to: "modal" } }, [
            _c(
              "div",
              {
                staticClass:
                  "fixed inset-0 z-50 flex items-center justify-center overscroll-contain",
              },
              [
                _c("div", {
                  staticClass: "absolute inset-0 bg-gray-800 opacity-[.64]",
                  on: { click: _vm.close },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "form",
                    staticClass:
                      "fixed subscribe w-full sm:w-[440px] p-[40px] bg-gray-300 text-gray-800",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "absolute top-[18px] right-[18px] cursor-pointer select-none text-gray-400 hover:text-gray-800",
                        on: { click: _vm.close },
                      },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.svg("x")) },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h3", { staticClass: "text-gray-900 font-bold mb-md" }, [
                      _vm._v(_vm._s(_vm.campaignTitle)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ValidationObserver",
                      {
                        ref: "observer",
                        attrs: { tag: "form" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit("/api/subscribe")
                          },
                        },
                      },
                      [
                        _c("ValidationProvider", {
                          ref: "first_name",
                          attrs: {
                            vid: "first_name",
                            rules: "min:2",
                            name: _vm.translations.first_name,
                            slim: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-sm group",
                                        class: props.classes,
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-xxs text-sm font-bold",
                                            attrs: { for: "first_name" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.translations.first_name
                                                ) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-red hidden group-[.required]:inline",
                                              },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.formData.first_name,
                                              expression: "formData.first_name",
                                            },
                                          ],
                                          staticClass:
                                            "form__input--filled-400 w-full form__input--lg",
                                          attrs: {
                                            type: "text",
                                            name: "first_name",
                                            placeholder:
                                              "Vul hier je voornaam in",
                                          },
                                          domProps: {
                                            value: _vm.formData.first_name,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.formData,
                                                "first_name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-red text-xs leading-none inline-block",
                                          },
                                          [_vm._v(_vm._s(props.errors[0]))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            809798522
                          ),
                        }),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          ref: "last_name",
                          attrs: {
                            vid: "last_name",
                            rules: "min:2",
                            name: _vm.translations.last_name,
                            slim: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-sm group",
                                        class: props.classes,
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-xxs text-sm font-bold",
                                            attrs: { for: "last_name" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.translations.last_name
                                                ) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-red hidden group-[.required]:inline",
                                              },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.formData.last_name,
                                              expression: "formData.last_name",
                                            },
                                          ],
                                          staticClass:
                                            "form__input--filled-400 w-full form__input--lg",
                                          attrs: {
                                            type: "text",
                                            name: "last_name",
                                            placeholder: "Vul hier je naam in",
                                          },
                                          domProps: {
                                            value: _vm.formData.last_name,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.formData,
                                                "last_name",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-red text-xs leading-none inline-block",
                                          },
                                          [_vm._v(_vm._s(props.errors[0]))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3990825742
                          ),
                        }),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          ref: "email",
                          attrs: {
                            vid: "email",
                            rules: "required|email",
                            name: _vm.translations.email,
                            slim: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mb-sm group",
                                        class: props.classes,
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "block mb-xxs text-sm font-bold",
                                            attrs: { for: "email" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.translations.email) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-red hidden group-[.required]:inline",
                                              },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.formData.email,
                                              expression: "formData.email",
                                            },
                                          ],
                                          staticClass:
                                            "form__input--filled-400 w-full form__input--lg",
                                          attrs: {
                                            type: "text",
                                            name: "email",
                                            placeholder:
                                              "Vul hier je e-mailadres in",
                                          },
                                          domProps: {
                                            value: _vm.formData.email,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.formData,
                                                "email",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-red text-xs leading-none inline-block",
                                          },
                                          [_vm._v(_vm._s(props.errors[0]))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            636242291
                          ),
                        }),
                        _vm._v(" "),
                        _c("ValidationProvider", {
                          ref: "newsletter",
                          attrs: {
                            vid: "newsletter",
                            rules: { required: { allowFalse: false } },
                            name: _vm.translations.newsletter,
                            slim: true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "relative mb-md",
                                        class: props.classes,
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form__checkbox form__checkbox--filled-dark flex",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.formData.newsletter,
                                                  expression:
                                                    "formData.newsletter",
                                                },
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id: "newsletter",
                                                placeholder:
                                                  _vm.translations.newsletter,
                                              },
                                              domProps: {
                                                checked: Array.isArray(
                                                  _vm.formData.newsletter
                                                )
                                                  ? _vm._i(
                                                      _vm.formData.newsletter,
                                                      null
                                                    ) > -1
                                                  : _vm.formData.newsletter,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a =
                                                      _vm.formData.newsletter,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.formData,
                                                          "newsletter",
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.formData,
                                                          "newsletter",
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "newsletter",
                                                      $$c
                                                    )
                                                  }
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              staticClass: "translate-y-[6px]",
                                              on: {
                                                click: _vm.checkboxSpanClicked,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                ref: "newletterlabel",
                                                attrs: { for: "newsletter" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.translations.newsletter
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        props.errors && props.errors.length
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-red text-xs leading-none inline-block mb-2",
                                              },
                                              [_vm._v(_vm._s(props.errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            410653464
                          ),
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "w-full btn btn--gray-dark btn--filled flex justify-center",
                            attrs: { type: "submit", disabled: _vm.processing },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.translations.submit)),
                            ]),
                            _vm._v(" "),
                            _vm.processing
                              ? _c("i", {
                                  staticClass:
                                    "fa-regular fa-spinner-third animate-spin",
                                })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.compiledErrors && _vm.compiledErrors.length
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "error text-red text-xs leading-none inline-block mb-5",
                              },
                              [_vm._v(_vm._s(_vm.compiledErrors[0]))]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }